// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__17V4B","input":"styles_input__2vPdE","labelFile":"styles_labelFile__KBd5Z"};